import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCart } from "../../hooks/useCart";
import { useCartModal } from "../../context/CartModalContext";
import { formatName } from "@/utils/formatName";
import styles from "./ProductCard.module.scss";

type OrderType = "exchpart" | "sellpart";

interface ProductCardProps {
  goid: string;
  name: string;
  price: number;
  table: string;
  imageUrl?: string;
  /** Тип замовлення: обмінна частина (exchpart) або продаж (sellpart). За замовчуванням sellpart. */
  typeorder?: OrderType;
}

const ProductCard: React.FC<ProductCardProps> = ({
  goid,
  name,
  price,
  table,
  imageUrl,
  typeorder = "sellpart",
}) => {
  const { t } = useTranslation("common");
  const fallbackImage = "/images/Shop/template.webp";
  const { addToCart } = useCart();
  const { openCart } = useCartModal();

  const formattedName = formatName(name);
  const linkPath =
    table === "service"
      ? `/service/${goid}/${formattedName}`
      : `/product/${goid}/${formattedName}`;

  const handleAddToCart = () => {
    addToCart({
      goid,
      typeorder,
      table,
    });

    openCart();
  };

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.card}>
        <div className={styles.imageWrapper}>
          <Link to={linkPath}>
            <img src={imageUrl || fallbackImage} alt={name} />
          </Link>
        </div>

        <Link to={linkPath} className={styles.name}>
          {name}
        </Link>

        <div className={styles.cartBtnCont}>
          <button
            className={styles.cartBtn}
            onClick={handleAddToCart}
            aria-label={t("shop.addToCart", { product: name, price: price })}
          >
            {price}€<p className={styles.plus}>+</p>
            <svg
              className={styles.cartIcon}
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              fill="none"
              aria-hidden="true"
            >
              <path
                fill="#fff"
                d="M5.459 4a4 4 0 0 1 3.72 2.531l6.252 15.836a1 1 0 0 0 .93.633h10.23a1 1 0 0 0 .941-.664l3.572-10A1 1 0 0 0 30.162 11H14a1 1 0 1 1 0-2h16.162c2.075 0 3.523 2.055 2.825 4.009l-3.571 10A3 3 0 0 1 26.591 25H16.36a3 3 0 0 1-2.79-1.898L7.318 7.266A2 2 0 0 0 5.46 6H3a1 1 0 0 1 0-2h2.459Z"
              />
              <circle cx="15" cy="29" r="2" fill="#fff" />
              <circle cx="28" cy="29" r="2" fill="#fff" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
